import { render, staticRenderFns } from "./HistoricalSalesByItem.vue?vue&type=template&id=3a862588"
import script from "./HistoricalSalesByItem.vue?vue&type=script&lang=js"
export * from "./HistoricalSalesByItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports